// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cai-search-content {
  padding: 2px 24px !important;
  background-color: #f0f0f0;
}

::ng-deep .mat-mdc-dialog-actions {
  background-color: #f0f0f0;
  padding: 8px 24px !important;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

.button-gap {
  gap: 12px;
}

.cai-search-layout {
  display: flex;
  gap: 0;
  min-height: 340px;
}

.commonly-used-panel {
  width: 360px;
  flex-shrink: 0;
  transition: width 160ms ease;
}

.commonly-used-panel--editing {
  width: 540px;
}

.panel-heading-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 30px;
}

.edit-list-button,
.add-common-user-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 0;
  color: #0b2d71;
  background: transparent;
  font-weight: 600;
}

.edit-list-button {
  font-size: 0.78rem;
  padding: 2px 4px;
}

.edit-list-button mat-icon,
.add-common-user-button mat-icon {
  width: 18px;
  height: 18px;
  font-size: 18px;
}

.add-common-user-button {
  width: 100%;
  margin-top: 6px;
  padding: 6px;
  border: 1px dashed #8da6c9;
  border-radius: 3px;
  font-size: 0.8rem;
}

.edit-list-button:hover,
.add-common-user-button:hover {
  background-color: #e8f1fb;
}

.panel-divider {
  width: 1px;
  background: #dee2e6;
  margin: 0 16px;
}

.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  width: 100%;
}

.search-panel {
  flex: 1;
  min-width: 0;
  overflow: hidden;
}

.results-scroll {
  overflow-x: auto;
  width: 100%;
}

.panel-heading {
  font-size: 0.85rem;
  color: #0b2d71;
  margin-bottom: 6px;
  font-weight: 600;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: nowrap;
}

.search-label {
  font-size: 0.8rem;
  white-space: nowrap;
  margin-bottom: 0;
}

.search-input {
  width: 130px;
  height: 30px;
  font-size: 0.82rem;
  padding: 2px 6px;
}

.cai-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.82rem;
}

.cai-table thead tr {
  background-color: #e9ecef;
}

.cai-table th,
.cai-table td {
  border: 1px solid #dee2e6;
  padding: 4px 8px;
  text-align: left;
  white-space: nowrap;
}

table.cai-table tbody tr {
  background-color: #fff;
}

.cai-row {
  cursor: pointer;
}

.cai-row--editable {
  cursor: default;
}

.common-user-input {
  width: 100%;
  min-width: 120px;
  height: 28px;
  padding: 2px 5px;
  border: 1px solid #9aa7b5;
  border-radius: 3px;
  font-size: 0.8rem;
}

.actions-column,
.row-actions {
  width: 86px;
  text-align: center !important;
}

.row-actions {
  padding: 0 2px !important;
}

.row-actions button {
  width: 34px;
  height: 34px;
  padding: 5px;
}

.row-actions mat-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}

.delete-action {
  color: #b42318;
}

.new-user-row td {
  background-color: #eef6ff;
}

table.cai-table .cai-row:not(.cai-row--editable):hover,
table.cai-table .cai-row:not(.cai-row--editable):hover > td {
  background-color: #cfe2ff;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/shared/user-search-dialog/user-search-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":[".cai-search-content {\n  padding: 2px 24px !important;\n  background-color: #f0f0f0;\n}\n\n::ng-deep .mat-mdc-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 8px 24px !important;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.cai-search-layout {\n  display: flex;\n  gap: 0;\n  min-height: 340px;\n}\n\n.commonly-used-panel {\n  width: 360px;\n  flex-shrink: 0;\n  transition: width 160ms ease;\n}\n\n.commonly-used-panel--editing {\n  width: 540px;\n}\n\n.panel-heading-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 30px;\n}\n\n.edit-list-button,\n.add-common-user-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  border: 0;\n  color: #0b2d71;\n  background: transparent;\n  font-weight: 600;\n}\n\n.edit-list-button {\n  font-size: 0.78rem;\n  padding: 2px 4px;\n}\n\n.edit-list-button mat-icon,\n.add-common-user-button mat-icon {\n  width: 18px;\n  height: 18px;\n  font-size: 18px;\n}\n\n.add-common-user-button {\n  width: 100%;\n  margin-top: 6px;\n  padding: 6px;\n  border: 1px dashed #8da6c9;\n  border-radius: 3px;\n  font-size: 0.8rem;\n}\n\n.edit-list-button:hover,\n.add-common-user-button:hover {\n  background-color: #e8f1fb;\n}\n\n.panel-divider {\n  width: 1px;\n  background: #dee2e6;\n  margin: 0 16px;\n}\n\n.loader-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 120px;\n  width: 100%;\n}\n\n.search-panel {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.results-scroll {\n  overflow-x: auto;\n  width: 100%;\n}\n\n.panel-heading {\n  font-size: 0.85rem;\n  color: #0b2d71;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.search-bar {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: nowrap;\n}\n\n.search-label {\n  font-size: 0.8rem;\n  white-space: nowrap;\n  margin-bottom: 0;\n}\n\n.search-input {\n  width: 130px;\n  height: 30px;\n  font-size: 0.82rem;\n  padding: 2px 6px;\n}\n\n.cai-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.82rem;\n}\n\n.cai-table thead tr {\n  background-color: #e9ecef;\n}\n\n.cai-table th,\n.cai-table td {\n  border: 1px solid #dee2e6;\n  padding: 4px 8px;\n  text-align: left;\n  white-space: nowrap;\n}\n\ntable.cai-table tbody tr {\n  background-color: #fff;\n}\n\n.cai-row {\n  cursor: pointer;\n}\n\n.cai-row--editable {\n  cursor: default;\n}\n\n.common-user-input {\n  width: 100%;\n  min-width: 120px;\n  height: 28px;\n  padding: 2px 5px;\n  border: 1px solid #9aa7b5;\n  border-radius: 3px;\n  font-size: 0.8rem;\n}\n\n.actions-column,\n.row-actions {\n  width: 86px;\n  text-align: center !important;\n}\n\n.row-actions {\n  padding: 0 2px !important;\n}\n\n.row-actions button {\n  width: 34px;\n  height: 34px;\n  padding: 5px;\n}\n\n.row-actions mat-icon {\n  width: 20px;\n  height: 20px;\n  font-size: 20px;\n}\n\n.delete-action {\n  color: #b42318;\n}\n\n.new-user-row td {\n  background-color: #eef6ff;\n}\n\ntable.cai-table .cai-row:not(.cai-row--editable):hover,\ntable.cai-table .cai-row:not(.cai-row--editable):hover > td {\n  background-color: #cfe2ff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
